import React from 'react';

const sharedStyles =
  'w-[90px] h-[40px] flex justify-center items-center font-metric text-md rounded border-[1.5px] relative';
const activeStyles = 'text-action03 bg-action02 bg-opacity-20 border-action03 z-50';
const inactiveStyles = 'text-bw07 bg-bw00 border-bw05 z-10 hover:bg-action00 hover:border-action02 hover:text-bw08';
const newActiveStyles = 'text-action03 bg-action02 bg-opacity-20 border-action03 z-50';
const newInactiveStyles = 'text-bw07 bg-bw00 border-bw05 z-10 hover:bg-action00 hover:border-action02 hover:text-bw08';
const leftInactiveButtonStyles = 'rounded-r-none border-r-0';
const rightInactiveButtonStyles = 'rounded-l-none border-l-0';

const getStylesForTab = (isActive: boolean, useNewColors?: boolean) => {
  if (isActive && !useNewColors) return activeStyles;
  if (isActive && useNewColors) return newActiveStyles;
  if (!isActive && !useNewColors) return inactiveStyles;
  if (!isActive && useNewColors) return newInactiveStyles;
  return null;
};

interface ITabs {
  leftTabName: string;
  rightTabName: string;
  activeTab: string;
  onTabClick: (tabName: string) => void;
  testId: string;
  useNewColors?: boolean;
}

export const Tabs = ({ leftTabName, rightTabName, activeTab, onTabClick, testId, useNewColors }: ITabs) => {
  const renderLeftButton = (name: string, isActive: boolean) => (
    <button
      key={`button_tab_${name}`}
      type='button'
      className={`${sharedStyles} ${getStylesForTab(isActive, useNewColors)} ${!isActive ? leftInactiveButtonStyles : ''}`}
      onClick={onTabClick.bind(null, name)}
      data-testid={`${testId}__left-button`}
    >
      {name}
    </button>
  );
  const renderRightButton = (name: string, isActive: boolean) => (
    <button
      key={`button_tab_${name}`}
      type='button'
      className={`left-[-4px] ${sharedStyles} ${getStylesForTab(isActive, useNewColors)} ${!isActive ? rightInactiveButtonStyles : ''}`}
      onClick={onTabClick.bind(null, name)}
      data-testid={`${testId}__right-button`}
    >
      {name}
    </button>
  );
  return (
    <div className='flex w-[180px] mb-[20px]'>
      {renderLeftButton(leftTabName, activeTab === leftTabName)}
      {renderRightButton(rightTabName, activeTab === rightTabName)}
    </div>
  );
};
